import React, { useState } from "react";
import defaultImg from "../assets/img/bgImg.jpg";
import {
  Button,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Row,
  Col,
  Table,
} from "reactstrap";
import { useSelector } from "react-redux";
import classnames from "classnames";
import moment from "moment";
import ReviewModal from "./ReviewModal";

const ChatBookingModal = (props) => {
  const { slotChats } = useSelector((state) => state.chat);
  const { uid, user } = useSelector((state) => state.authUser);
  const [currentActiveTab, setCurrentActiveTab] = useState("1");
  const toggle = (tab) => {
    if (currentActiveTab !== tab) setCurrentActiveTab(tab);
  };
  const [receiverId, setReceiverId] = useState("");
  const [chatID, setChatID] = useState();
  const [showReview, setShowReview] = useState(false);

  const handleShowReview = (participant, chatID) => {
    setReceiverId(participant);
    setChatID(chatID);
    setShowReview(!showReview);
  };
  return (
    <>
      <Modal
        isOpen={props.showChatBookingModal}
        toggle={props.handleChatBookingModal}
        size="xl"
        top="true"
      >
        <ModalBody>
          <div className="d-flex justify-content-end">
            <div>
              <i
                onClick={props.handleChatBookingModal}
                className="fas fa-times"
              ></i>
            </div>
          </div>
          <div>
            <div className="p-2">
              <Nav
                className="d-flex justify-content-start text-dark reponsive-nav-tabs"
                tabs
              >
                <NavItem>
                  <NavLink
                    className={classnames("pointer", {
                      active: currentActiveTab === "1",
                    })}
                    onClick={() => {
                      toggle("1");
                    }}
                  >
                    Accepted
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames("pointer", {
                      active: currentActiveTab === "2",
                    })}
                    onClick={() => {
                      toggle("2");
                    }}
                  >
                    Rejected
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames("pointer", {
                      active: currentActiveTab === "3",
                    })}
                    onClick={() => {
                      toggle("3");
                    }}
                  >
                    Completed
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={currentActiveTab}>
                <TabPane tabId="1">
                  <Row>
                    <Col sm="12">
                      <div className="chat">
                        <Table
                          className="table mt-4 align-items-center"
                          responsive
                        >
                          <thead>
                            <tr>
                              <th scope="col" className="custom-table-heading">
                                {" "}
                              </th>
                              <th scope="col" className="custom-table-heading">
                                {user?.role == "athlete"
                                  ? "Booked By"
                                  : "Booked with"}
                              </th>
                              {user?.role == "athlete" ? (
                                <th
                                  scope="col"
                                  className="custom-table-heading"
                                >
                                  Email
                                </th>
                              ) : (
                                ""
                              )}
                              <th scope="col" className="custom-table-heading">
                                Date
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Window
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Amount Paid $
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Status
                              </th>
                            </tr>
                          </thead>
                          {slotChats?.length > 0 &&
                            slotChats
                              .filter((chat) => {
                                if (chat.status == "accepted") {
                                  return chat;
                                }
                              })
                              .map((ele, index) => {
                                return (
                                  <tbody key={index}>
                                    <tr>
                                      <td className="text-center custom-table-text">
                                        <img
                                          className="chat-profile"
                                          src={
                                            ele.chatUser.player_image
                                              ? ele.chatUser.player_image.url
                                              : defaultImg
                                          }
                                        />
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.chatUser?.role == "athlete"
                                          ? ele.chatUser?.first_name +
                                            " " +
                                            ele.chatUser?.last_name
                                          : ele.chatUser?.name}
                                      </td>
                                      {user?.role == "athlete" ? (
                                        <td className="table-chat-request custom-table-text">
                                          {ele?.fan_email}
                                        </td>
                                      ) : (
                                        ""
                                      )}

                                      <td className="table-chat-request custom-table-text">
                                        {moment
                                          .unix(ele.chat_start.seconds)
                                          .format("MMM Do YY")}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {moment
                                          .unix(ele.chat_start.seconds)
                                          .format("h:mm a")}{" "}
                                        -{" "}
                                        {moment
                                          .unix(ele.chat_end.seconds)
                                          .format("h:mm a")}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.paid_amount.value}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.status}
                                      </td>
                                    </tr>
                                  </tbody>
                                );
                              })}
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    <Col sm="12">
                      <div className="chat">
                        <Table
                          className="table mt-4 align-items-center"
                          responsive
                        >
                          <thead>
                            <tr>
                              <th scope="col" className="custom-table-heading">
                                {" "}
                              </th>
                              <th scope="col" className="custom-table-heading">
                                {" "}
                                {user?.role == "athlete"
                                  ? "Booked By"
                                  : "Booked with"}
                              </th>
                              {user?.role == "athlete" ? (
                                <th
                                  scope="col"
                                  className="custom-table-heading"
                                >
                                  Email
                                </th>
                              ) : (
                                ""
                              )}
                              <th scope="col" className="custom-table-heading">
                                Date
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Window
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Amount Paid $
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Status
                              </th>
                            </tr>
                          </thead>
                          {slotChats?.length > 0 &&
                            slotChats
                              .filter((chat) => {
                                if (chat.status == "rejected") {
                                  return chat;
                                }
                              })
                              .map((ele, index) => {
                                return (
                                  <tbody key={index}>
                                    <tr>
                                      <td className="text-center custom-table-text">
                                        <img
                                          className="chat-profile"
                                          src={
                                            ele.chatUser.player_image
                                              ? ele.chatUser.player_image.url
                                              : defaultImg
                                          }
                                        />
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.chatUser?.role == "athlete"
                                          ? ele.chatUser?.first_name +
                                            " " +
                                            ele.chatUser?.last_name
                                          : ele.chatUser?.name}
                                      </td>
                                      {user?.role == "athlete" ? (
                                        <td className="table-chat-request custom-table-text">
                                          {ele?.fan_email}
                                        </td>
                                      ) : (
                                        ""
                                      )}

                                      <td className="table-chat-request custom-table-text">
                                        {moment
                                          .unix(ele.chat_start.seconds)
                                          .format("MMM Do YY")}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {moment
                                          .unix(ele.chat_start.seconds)
                                          .format("h:mm a")}{" "}
                                        -{" "}
                                        {moment
                                          .unix(ele.chat_end.seconds)
                                          .format("h:mm a")}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.paid_amount.value}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.status}
                                      </td>
                                    </tr>
                                  </tbody>
                                );
                              })}
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="3">
                  <Row>
                    <Col sm="12">
                      <div className="chat">
                        <Table
                          className="table mt-4 align-items-center"
                          responsive
                        >
                          <thead>
                            <tr>
                              <th scope="col" className="custom-table-heading">
                                {" "}
                              </th>
                              <th scope="col" className="custom-table-heading">
                                {user?.role == "athlete"
                                  ? "Booked By"
                                  : "Booked with"}
                              </th>
                              {user?.role == "athlete" ? (
                                <th
                                  scope="col"
                                  className="custom-table-heading"
                                >
                                  Email
                                </th>
                              ) : (
                                ""
                              )}
                              <th scope="col" className="custom-table-heading">
                                Date
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Window
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Amount Paid $
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Status
                              </th>
                              <th scope="col" className="custom-table-heading">
                                Action
                              </th>
                            </tr>
                          </thead>
                          {slotChats?.length > 0 &&
                            slotChats
                              .filter((chat) => {
                                if (chat.status == "complete") {
                                  return chat;
                                }
                              })
                              .map((ele, index) => {
                                return (
                                  <tbody key={index}>
                                    <tr>
                                      <td className="text-center custom-table-text">
                                        <img
                                          className="chat-profile"
                                          src={
                                            ele.chatUser.player_image
                                              ? ele.chatUser.player_image.url
                                              : defaultImg
                                          }
                                        />
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.chatUser?.role == "athlete"
                                          ? ele.chatUser?.first_name +
                                            " " +
                                            ele.chatUser?.last_name
                                          : ele.chatUser?.name}
                                      </td>
                                      {user?.role == "athlete" ? (
                                        <td className="table-chat-request custom-table-text">
                                          {ele?.fan_email}
                                        </td>
                                      ) : (
                                        ""
                                      )}

                                      <td className="table-chat-request custom-table-text">
                                        {moment
                                          .unix(ele.chat_start.seconds)
                                          .format("MMM Do YY")}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {moment
                                          .unix(ele.chat_start.seconds)
                                          .format("h:mm a")}{" "}
                                        -{" "}
                                        {moment
                                          .unix(ele.chat_end.seconds)
                                          .format("h:mm a")}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.paid_amount.value}
                                      </td>
                                      <td className="table-chat-request custom-table-text">
                                        {ele.status}
                                      </td>
                                      <td className="table-chat-request custom-table-text whitespace-nowrap text-center">
                                        <Button
                                          disabled={ele.is_reviewed_athlete}
                                          className="btn-sm mx-auto whitespace-nowrap"
                                          color="primary"
                                          onClick={() => {
                                            handleShowReview(
                                              ele.participants.filter(
                                                (ele) => ele != uid
                                              ),
                                              ele.id
                                            );
                                          }}
                                        >
                                          {" "}
                                          Review Chat
                                        </Button>
                                      </td>
                                    </tr>
                                  </tbody>
                                );
                              })}
                        </Table>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <ReviewModal
        showReviewModal={showReview}
        handleShowReview={() => {
          handleShowReview("", "");
        }}
        chatID={chatID}
        athleteId={receiverId[0]}
      ></ReviewModal>
    </>
  );
};

export default ChatBookingModal;
